// @ts-nocheck
import { ListItem, ListItemButton, ListItemText } from '@mui/material';
import React, { MouseEventHandler } from 'react';
import { LinkedRecord } from '../../../shared/material_components/linked-cell';

interface Props {
  record: LinkedRecord,
  onClick?: (record: LinkedRecord) => void,
}

const RecordLink: React.FC<Props> = ({ record, onClick = () => {} }) => {
  const handleClick = (e: MouseEventHandler<HTMLElement>) => {
    e.preventDefault();
    onClick(record);
  };

  return (
    <ListItem onClick={handleClick} disablePadding>
      <ListItemButton>
        <ListItemText primary={record?.title || 'Untitled Record'} />
      </ListItemButton>
    </ListItem>
  );
};

export default RecordLink;
